// account types
export const VENDOR = 'Vendor';
export const SELLER = 'Seller';
export const HYBRID = 'Hybrid';
export const VENDORSMALL = 'vendor';
export const SELLERSMALL = 'seller';
export const HYBRIDSMALL = 'hybrid';
export const ONEPVALUE = '1p';
export const THREEPVALUE = '3p';
export const ONEP = '1P';
export const THREEP = '3P';
export const SELLER_ACCOUNT_TYPES = [SELLER, ONEP];
export const VENDOR_ACCOUNT_TYPES = [VENDOR, THREEP];

// performance tabs
export const AMCINSIGHTS = 'amcInsights';
export const CREATIVEPROJECTS = 'creativeProjects';
export const ADPERFORMANCE = 'adPerformance';
export const SALEPERFORMANCE = 'salePerformance';
export const DSPPERFORMANCE = 'dspPerformance';

// channel types
export const AMAZON = 'Amazon';
export const AMAZONSMALL = 'amazon';
export const WALMARTSMALL = 'walmart';
export const WALMART = 'Walmart';
export const TARGET = 'target';
export const PAIDSOCIAL = 'paid social';
export const PAID_SOCIAL = 'paid_social';
export const PAIDSEARCH = 'paid search';
export const PAID_SEARCH = 'paid_search';

// general
export const PARENT = 'parent';

// time frames
export const YEAROVERYEAR = 'yearOverYear';
export const CUSTOM = 'custom';

// sales metrics - seller
export const UNITSSOLD = 'unitsSold';
export const TRAFFIC = 'traffic';
export const CONVERSION = 'conversion';
export const TACOS = 'tacos';
export const REVENUETOTAL = 'revenueTotal';
export const REVENUEORGANIC = 'revenueOrganic';
export const REVENUEPPC = 'revenuePpc';
export const REVENUEDSP = 'revenueDsp';

// sales metrics - vendor
export const ORDEREDREVENUE = 'orderedRevenue';
export const SHIPPEDCOGS = 'shippedCOGs';
export const GLANCEVIEWS = 'glanceViews';
export const CONVERSIONRATE = 'conversionRate';
export const SHIPPEDUNITS = 'shippedUnits';
export const ORDEREDUNITS = 'orderedUnits';

// sponsored metrics
export const ADSALES = 'adSales';
export const ADSPENDTOTAL = 'adSpendTotal';
export const ADSPENDPPC = 'adSpendPpc';
export const ADSPENDDSP = 'adSpendDsp';
export const ADSPEND = 'adSpend';
export const SPONSOREDADSPEND = 'sponsoredAdSpend';
export const DSPSPEND = 'dspSpend';
export const NTBORDERS = 'ntbOrders';
export const NTBSALES = 'ntbSales';
export const PERCENTAGENTBORDERS = 'percentageNtbOrders';
export const PERCENTAGENTBSALES = 'percentageNtbSales';
export const ACOS = 'acos';
export const ROAS = 'roas';
export const ADROAS = 'adRoas';
export const ADCOS = 'adCos';
export const SALESPERCLICK = 'salesPerClick';
export const COSTPERCLICK = 'costPerClick';
export const ADCONVERSION = 'adConversion';
export const ADCLICKRATE = 'adClickRate';
export const IMPRESSIONS = 'impressions';

// Asin and campaign
export const ASIN = 'asin';
export const CAMPAIGN = 'campaign';

// sales goals metrics key
export const OVERALLSALESGOALS = 'overall_sales_goals';
export const PPCADBUDGET = 'ppc_ad_budget';
export const DSPADBUDGET = 'dsp_ad_budget';
export const REVSHARE = 'rev_share';

// Dashboard
export const PERFORMANCE = 'performance';
export const KEYMETRICS = 'keyMetrics';
export const CONTRIBUTION = 'contribution';
export const POSITIVE = 'positive';

// channel
export const channel = {
  AMAZON: AMAZONSMALL,
  WALMART: WALMARTSMALL,
  PAID_SOCIAL: PAIDSOCIAL,
  PAID_SEARCH: PAIDSEARCH,
  TARGET,
};

export const amazonWalmartChannel = [channel.AMAZON, channel.WALMART];

export const socialGoogleTargetChannel = [
  channel.PAID_SOCIAL,
  channel.PAID_SEARCH,
  channel.TARGET,
];
